import BaseReducer from "shared/types/baseReducer";
import { StaticDataAction, StaticDataActionType, StaticDataDispatchInterface, StaticDataState } from "./staticData.d";

export default class Reducer extends BaseReducer<StaticDataActionType> implements StaticDataDispatchInterface {
  static reducer(state: StaticDataState, action: StaticDataActionType) {
    switch (action.type) {
      case StaticDataAction.CHANGE_LANGUAGE_TYPE:
        return { ...state, languageType: action.payload };
    }
  }

  public changeLanguageType(payload: string): void {
    return this.dispatch({ type: StaticDataAction.CHANGE_LANGUAGE_TYPE, payload });
  }
}
